export default "__VITE_ASSET__4970a495__"